import { render } from "./SelectPlayerRow.vue?vue&type=template&id=24e0657a&ts=true"
import script from "./SelectPlayerRow.vue?vue&type=script&lang=ts"
export * from "./SelectPlayerRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__